import { render } from "./index.vue?vue&type=template&id=ab7ed3ca&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=ab7ed3ca&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab7ed3ca"],['__file',"src/views/sms/send/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ab7ed3ca"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ab7ed3ca', __exports__)) {
    console.log('reload')
    api.reload('ab7ed3ca', __exports__)
  }
  
  module.hot.accept("./index.vue?vue&type=template&id=ab7ed3ca&scoped=true", () => {
    console.log('re-render')
    api.rerender('ab7ed3ca', render)
  })

}


export default __exports__